import Http from './http'

export const getEntities = (clientId) => Http.get(`/customEntities/${clientId}`)
export const getCustomFieldsByEntityType = (entityType, clientId) => Http.get(`/customFields/entityType/${entityType}/clientId/${clientId}`)
export const getCustomFieldsByEntityId = (customEntityId) => Http.get(`/customFields/${customEntityId}`)

export default {
  getEntities,
  getCustomFieldsByEntityType,
  getCustomFieldsByEntityId
}